/**
 * Class that represents a additional navigation element for the step navigation.
 */
export class StepNavigationElement {
  private _textPrefix: string;
  private _isActive: boolean;
  private _url: string;

  public constructor(textPrefix: string, isActive: boolean, url: string = null) {
    this._textPrefix = textPrefix;
    this._isActive = isActive;
    this._url = url;
  }

  get textPrefix(): string {
    return this._textPrefix;
  }

  set textPrefix(value: string) {
    this._textPrefix = value;
  }

  get isActive(): boolean {
    return this._isActive;
  }

  set isActive(value: boolean) {
    this._isActive = value;
  }

  get url(): string {
    return this._url;
  }

  set url(value: string) {
    this._url = value;
  }
}
